
import React, { useState } from "react";
import { Button, FormLabel, FormElement, FormInput, CancelButton } from "../../../../components/StyledElements";
import { useCourseContext } from "../../../../contexts/CoursesContext";
import { updateLevel } from "../../../../services/courses";
import swal from "sweetalert2";


export const CoreDetails = ({ courseLevel, style = {}, onSelectTab = () => { } }) => {
  const { updatedCourse } = useCourseContext();

  const [updatedLevel, setUpdatedLevel] = useState(courseLevel);
  const [currentLevel, setCurrentLevel] = useState(courseLevel);
  const [savingLevel, setSavingLevel] = useState(false);

  const hasChanged = () => {
    return JSON.stringify(updatedLevel) !== JSON.stringify(currentLevel);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>
      <div style={{ position: "absolute", top: 20, right: 20, display: "flex", zIndex: 200, flexDirection: "row", gap: "10px" }}>
        <CancelButton onClick={() => {
          swal.fire({
            title: "Are you sure?",
            text: "Any unsaved changes will be lost.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, cancel",
            cancelButtonText: "No, keep editing",
          }).then((result) => {
            if (result?.value) {
              setUpdatedLevel(currentLevel);
            }
          });
        }}>Cancel</CancelButton>
        <Button disabled={!hasChanged() || savingLevel} style={{ marginLeft: "auto" }}
          onClick={async () => {
            if (!hasChanged()) {
              return;
            }


            // open a sweetalert2 modal until the save is complete
            swal.fire({
              title: "Saving...",
              text: "Please wait while the level is being saved.",
              allowOutsideClick: false,
              didOpen: () => {
                swal.showLoading();
              },
            });

            setSavingLevel(true);
            const results = await updateLevel(updatedLevel);
            setSavingLevel(false);

            if (results.success) {
              //const newUpdatedBlock = results.content_block;
              setCurrentLevel(updatedLevel);
              swal.fire({
                title: "Success",
                text: "Level block saved successfully.",
                icon: "success",
              });
            } else {
              swal.fire({
                title: "Error",
                text: results.error || "An error occurred while saving the level.",
                icon: "error",
              });
            }
          }}
        >
          {savingLevel ? "Saving Level..." : "Save Level"}
        </Button>
      </div>

      <FormElement style={{ flexDirection: "column", display: "flex" }}>
        {
          updatedCourse?.document_count ? (
            <FormLabel label={`${updatedCourse.document_count} Items`} />
          ) : null}
        {
          updatedCourse?.collection_chunk_count ? (
            <FormLabel label={`${updatedCourse.collection_chunk_count} Chunked Items`} />
          ) : null}
      </FormElement>

      <FormElement>
        <FormLabel label="Public ID" />
        <FormInput disabled type="text" value={courseLevel?.public_id ?? ""} />
      </FormElement>
      <FormElement>
        <FormLabel label="Title" />
        <FormInput type="text" placeholder="Enter course level title" value={updatedLevel?.title ?? ""}
          onChange={(e) => {
            //setUpdatedCourse({ ...updatedCourse, title: e.target.value });
            setUpdatedLevel({ ...updatedLevel, title: e.target.value });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Description" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter description"
          style={{ resize: "vertical" }}
          value={updatedLevel?.description ?? ""}
          onChange={(e) => {
            setUpdatedLevel({ ...updatedLevel, description: e.target.value });
            //updatedCourse.description = e.target.value;
            //setUpdatedCourse({ ...updatedCourse });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Short Description" />
        <FormInput
          as="textarea"
          rows={2}
          placeholder="Enter short description"
          style={{ resize: "vertical" }}
          value={updatedLevel?.short_description ?? ""}
          onChange={(e) => {
            setUpdatedLevel({ ...updatedLevel, short_description: e.target.value });
            //updatedCourse.description = e.target.value;
            //setUpdatedCourse({ ...updatedCourse });
          }}
        />
      </FormElement>
    </div>
  );
};

export default CoreDetails;
